import React from 'react';
import { StyleSheet, ViewStyle, Platform } from 'react-native';

import styled from 'styled-components/native';
import { color, ColorProps, border, BorderProps } from 'styled-system';

import { CardBase } from 'theme/card';
import { Colors } from 'theme/colors';
import { NakedIcon } from 'theme/icons';

const ITEM_HEIGHT = 60;
const BUTTON_HEIGHT = Platform.select({ default: 40, web: 50 });
const BORDER_RADIUS = Platform.select({ default: 20, web: 25 });
const ICON_TOP = Platform.select({ default: 5, web: 10 });

export const Item = styled.TouchableOpacity`
  height: ${ITEM_HEIGHT}px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: ${Colors.lightGrey};
  flex-direction: row;
  align-items: center;
  border-bottom-width: ${StyleSheet.hairlineWidth}px;
  border-bottom-color: ${Colors.celeste};
`;

export const Circle = styled.View<BorderProps>`
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  border-width: 1px;
  border-color: ${Colors.green};
  background-color: ${Colors.white};
  justify-content: center;
  align-items: center;
  ${border}
`;

export const Label = styled.View`
  flex: 1;
  padding-left: 10px;
`;

export const ButtonContainer = styled.TouchableOpacity<ViewStyle & ColorProps>`
  justify-content: center;
  height: ${BUTTON_HEIGHT}px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: ${BORDER_RADIUS}px;
  background-color: ${Colors.green};
  position: relative;
  margin-left: ${({ marginHorizontal }: ViewStyle) => marginHorizontal || 0}px;
  margin-right: ${({ marginHorizontal }: ViewStyle) => marginHorizontal || 0}px;
  ${color}
`;

export const ButtonIconCircle = styled.View<ColorProps>`
  height: 30px;
  width: 30px;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${ICON_TOP}px;
  ${color};
`;

/**
 * Dropdown styles
 */
export const DropdownContainer = styled.View`
  top: 0px;
  left: 0px;
  right: 0px;
  background-color: ${Colors.white};
  border-radius: 15px;
`;

export const DropdownContent = styled.View`
  border-radius: 15px;
  overflow: hidden;
  background-color: ${Colors.white};
`;

export const DropdownItemContainer = styled.View`
  border-bottom-width: ${StyleSheet.hairlineWidth}px;
  border-bottom-color: ${Colors.alto};
`;

export const DropdownItemButton = styled.TouchableOpacity<ColorProps>`
  padding-top: 15px;
  padding-bottom: 15px;
  align-items: center;
  margin: 5px;
  border-radius: 15px;
  background-color: ${Colors.white};
  ${color}
`;

interface RotatingIcon {
  color: Colors;
  expanded: boolean;
}

export const RotatingIcon = (props: RotatingIcon) => (
  <NakedIcon color={props.color} name={props.expanded ? 'arrow-up' : 'arrow-down'} size={11} />
);

export const RoundedCardBase = styled(CardBase)``;
